import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import DepositHistoryPage, { getDefaultPageUI } from "components/pages/DepositHistoryPage";

export default function CaptureDepositsSearch(props){
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "showSearchAccordion" ], true)
        .submit();

    return <DepositHistoryPage ui={ ui } />
}